module.exports = __webpack_public_path__ + "img/2025-07-21a_8.f52d1cc9.jpg";